module.exports = __webpack_public_path__ + "static/img/vip-new-window-up.cff9f537.png";